import React, { useEffect, useState } from 'react';
import { ClipboardCheck, AlertTriangle, CheckCircle2, Camera } from 'lucide-react';
import api from '../lib/api';
import { InspectionDialog } from '../pages/ServiceDelivery';

const fmtD = (s) => (s ? new Date(s).toLocaleDateString('pt-BR') : '');

export const CustomerInspections = ({ deals = [] }) => {
  const [sums, setSums] = useState({});
  const [openId, setOpenId] = useState(null);
  useEffect(() => {
    let alive = true;
    Promise.all(deals.map((d) => api.get(`/deals/${d.id}/service/summary`).then((r) => [d.id, r.data]).catch(() => [d.id, null])))
      .then((rows) => { if (alive) setSums(Object.fromEntries(rows)); });
    return () => { alive = false; };
  }, [deals]);
  const rows = deals.filter((d) => sums[d.id]?.exists);
  return (
    <div className="space-y-2" data-testid="customer-inspections">
      {rows.map((d) => {
        const s = sums[d.id]; const ready = !!s.ready_at;
        return (
          <button key={d.id} data-testid={`customer-inspection-${d.id}`} onClick={() => setOpenId(d.id)} className="w-full text-left rounded-lg border border-border/70 bg-popover p-3 hover:border-primary/50 transition-colors">
            <div className="flex items-center gap-2 flex-wrap">
              <ClipboardCheck className="w-3.5 h-3.5 text-primary" /><p className="font-semibold text-sm">Delivery Inspection — {d.vehicle_desc}</p>
              {ready ? <span className="ent-tag t-ok">Concluída {fmtD(s.ready_at)}</span> : <span className="ent-tag t-warn">Em andamento</span>}
              {s.open_problems.length > 0 && <span className="ent-tag t-bad"><AlertTriangle className="w-3 h-3" /> {s.open_problems.length} pendência(s)</span>}
              <span className="text-[11px] text-muted-foreground ml-auto">{d.id}</span>
            </div>
            <p className="text-[11px] text-muted-foreground mt-1 flex items-center gap-2 flex-wrap">
              <span className="flex items-center gap-1"><CheckCircle2 className="w-3 h-3 text-emerald-400" /> {s.ok} OK</span>
              {s.problems > 0 && <span>· {s.problems} problema(s), {s.resolved} resolvido(s)</span>}
              {s.na > 0 && <span>· {s.na} N/A</span>}
              <span className="flex items-center gap-1">· <Camera className="w-3 h-3" /> {s.photos} foto(s)</span>
              {ready && <span>· por {s.ready_by}</span>}
              {s.delivery?.delivered_at && <span>· Entregue {fmtD(s.delivery.delivered_at)}</span>}
            </p>
          </button>
        );
      })}
      {rows.length === 0 && <p className="text-sm text-muted-foreground/70">Nenhuma inspeção de entrega registrada.</p>}
      <InspectionDialog dealId={openId} open={!!openId} onClose={() => setOpenId(null)} onChanged={() => {}} />
    </div>
  );
};
